import { ADD_ITEM, REMOVE_ITEM, UPDATE_TOTAL_PRICE } from './actions';

// Initial state
const initialState = {
  selectedItems: [],
  totalPrice: 0,
};

// Reducer
const reducer = (state = initialState, action) => {
  switch (action.type) {
    case ADD_ITEM:
      return {
        ...state,
        selectedItems: [...state.selectedItems, action.payload],
        totalPrice: state.totalPrice + action.payload.price,
      };
    case REMOVE_ITEM:
      return {
        ...state,
        selectedItems: state.selectedItems.filter(
          (item) => item !== action.payload,
        ),
        totalPrice: state.totalPrice - action.payload.price,
      };
    case UPDATE_TOTAL_PRICE:
      return {
        ...state,
        totalPrice: action.payload,
      };
    default:
      return state;
  }
};

export default reducer;
